import React, {useEffect, useState} from "react";
import {Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useApolloClient} from "@apollo/client";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhonePlus} from "@fortawesome/pro-solid-svg-icons";

const ListItemMenuButton = ({ sx, sxButton, children, menuItems }) => {

	const {t} = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClose = (e) => {
		e?.stopPropagation();
		setAnchorEl(null);
	};

	return (
		<Box sx={{display: "flex", justifyContent: "end", ...sx }}>
			<IconButton
				sx={{height: "20px", paddingRight: 0,
					"&:hover": {
						backgroundColor: "#c1d6f4"
					},
					...sxButton
				}}
				onClick={(e) => {
					e.stopPropagation();
					setAnchorEl(e.currentTarget);
				}}
				aria-controls={open ? "account-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
			>
				{children}
			</IconButton>
			<Menu
				aria-labelledby="menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				sx={{padding: 0}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right"
				}}
			>
				{menuItems &&
					menuItems.map((item, index) => (
						 item.visible && <MenuItem
							key={index}
							sx={ index === 0 ? {paddingTop: "0px", px: 0} : {paddingTop: "10px", px: 0}}
							disabled={item.function === undefined}
							onClick={(e) => {
								e.stopPropagation();
								if (item.function !== undefined) {
									item.function();
								}
								handleClose();
							}}
						>
							<ListItemIcon sx={{justifyContent: "center", pr: 1}}>
								<FontAwesomeIcon icon={item.icon} size={"lg"} fixedWidth/>
							</ListItemIcon>
							<ListItemText
								primary={t(item.primaryText)}
								secondary={t(item.secondaryText)}
								slotProps={{
									primary: {
										variant: "h5"
									}
								}}
							>

							</ListItemText>
						</MenuItem>
					))
				}
			</Menu>
		</Box>
	);
};
export default ListItemMenuButton;
